import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gpe-edit',
  templateUrl: './edit.component.svg',
})
export class EditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
